export default {
  created () {
    //push home for redirect uri in keycloak
    this.$router.push('home')
    this.$store.dispatch('auth/logout').then(
      () => {
        this.$keycloak.logout()
      }
    )
  }
}
